// extracted by mini-css-extract-plugin
module.exports = {"blocker":"styles_blocker__2KHO-","blocker__img":"styles_blocker__img__1o3ug","blocker__title":"styles_blocker__title__1GrJM","blocker__text":"styles_blocker__text__1gF5Z"};